import NivelFornecedor from '@/spa/nivel-fornecedor/NivelFornecedor';

export default {
  path: 'nivel-fornecedor',
  name: 'nivel-fornecedor',
  component: NivelFornecedor,
};
